import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  GetGitRefsResponse,
  GitConnectionCredentials
} from '@eggplant/types'

interface Props {
  params: GitConnectionCredentials
  onError: (error: Error) => void
  onSuccess: (data: GetGitRefsResponse) => void
}

const UpdateGitCredentialRequest = ({
  params,
  onError,
  onSuccess
}: Props) => {
  const url = `${VAM_SERVICE}/repositories/refs`

  return (
    <AuthenticatedDataRequest
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateGitCredentialRequest
